import { FC } from 'react';

import { IconButton, Paper } from '@mui/material';
import { useBusinessToolSessionStore } from 'store/useBusinessToolStore';
import { getBusinessToolMode } from 'store/useBusinessToolStore/selectors';

import { checkIsPreviewMode } from 'pages/BusinessToolPage/utils';

import { ReactComponent as InformationCircleIcon } from 'assets/icons/InformationCircleIcon.svg';

import styles from './InstructionButton.module.scss';

interface IProps {
  onClick: VoidFunction;
}

export const InstructionButton: FC<IProps> = ({ onClick }) => {
  const businessToolMode = useBusinessToolSessionStore(getBusinessToolMode);
  const isPreviewMode = checkIsPreviewMode(businessToolMode);

  if(isPreviewMode) {
    return null;
  }
  return (
    <Paper elevation={3}>
      <IconButton onClick={onClick} className={styles.button}>
        <InformationCircleIcon className={styles.icon} />
      </IconButton>
    </Paper>
  );
};
